import gql from 'graphql-tag'

const organizationFragment = gql`
    fragment organization on OrganizationType {
        id
        externalId
        contactPosition
        contactPhone
        contactName
        contactEmail
        billingAddressIsPhysicalAddress
        membershipActivatedAt
        membershipExpiresAt
        name
        subdomain
        vatNumber
        billingDepartment
        cocNumber
        language
        admins {
            firstName
            email
            id
            lastName
            hasLoggedOn
        }
        billingAddress {
            addressLine1
            addressLine2
            city
            country
            postalCode
            state
        }
        physicalAddress {
            addressLine1
            addressLine2
            city
            country
            postalCode
            state
        }
        images {
            edges {
                node {
                    id
                    file
                }
            }
        }
    }
`

export const getOrganization = gql`
    query getOrganization($id: ID!) {
        organization(id: $id) {
            ...organization
        }
    }
    ${organizationFragment}
`

export const getEvents = gql`
    query getEvents($filters: MyEventFilters) {
        myEvents(filters: $filters) {
            edges {
                node {
                    id
                    createdAt
                    startDate
                    endDate
                    name
                    slug
                    description
                    firstPublishedAt
                    organization {
                        id
                    }
                    admins {
                        edges {
                            node {
                                firstName
                                email
                                id
                                lastName
                                hasLoggedOn
                            }
                        }
                    }
                }
            }
        }
    }
`
